export const ACCENT = '#E8B04B';
// Açık zeminde okunabilirlik için accent'in %45 koyulaştırılmış hali
export const ACCENT_DARK = '#806129';
export const WARM = '#EF6F5E';

export const SANS = "'Geist', ui-sans-serif, system-ui, sans-serif";
export const MONO = "'Geist Mono', ui-monospace, monospace";
export const HAND = "'Caveat', cursive";

export function hexA(hex: string, alpha: number) {
  const n = parseInt(hex.replace('#', ''), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}
